import React from 'react';
export function Solution() {
  return <section className="bg-white py-10 md:py-14" data-id="element-83">
      <div className="max-w-3xl mx-auto px-6 text-center" data-id="element-84">
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-ink mb-6 leading-tight" data-id="element-85">
          Una solución completa, sin complicaciones
        </h2>
        <p className="text-lg text-gray-600 leading-relaxed" data-id="element-86">
          Las +450 Recetas Saludables reúnen todo lo que necesitas para
          alimentar a tu mascota de forma natural, segura y profesional — sin
          perder horas buscando recetas en internet.
        </p>
      </div>
    </section>;
}